<!-- 
  @template SelectLocationComponent
  A dropdown (`ion-select`) that allows users to choose a location.
  - Binds to `selectedLocationName` using `ngModel`
  - Populates dropdown options dynamically from `locationsRecord`
  - Emits selection changes to the parent component
-->

<ion-item lines="none" style="max-width: 400px; width: 100%;">
  <div>
    <ion-select
      class="location-select"
      style="font-size: 1rem;"
      [label]="showFieldLabel ? 'Location:' : ''"
      interface="popover"
      (ionChange)="handleLocationChange($event)"
      [(ngModel)]="selectedLocationName">
      
      <!-- Dynamically generates the dropdown options based on location names -->
      <ion-select-option 
        *ngFor="let location of locationNames" 
        [value]="location">
        {{ locationsRecord[location] }}
      </ion-select-option>

    </ion-select>
  </div>
</ion-item>
